<template>
  <div>
    <returned-checks-table 
      ref='table' 
      kind="concluded" 
      :items="allReturnedChecks" 
      with_date_search 
      @dateSearched="handleDateSearch" 
      :loading="loading" 
      :headers="headers" 
      @doneUpdate="handleDoneUpdate"
      @doneFilter="handleDoneFilter"
      @clientSelected="handleClientSelected"
    ></returned-checks-table>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ReturnedChecksConcluded',
  inject: {
    registerReturnedChecksListReload: {
      default: () => () => {},
    },
  },
  components: {
    ReturnedChecksTable: () => import('./shared/ReturnedChecksTable'),
  },
  data() {
    return {
      headers: [
        { text: '#', value: 'attributes.id', align: 'center' },
        { text: 'Cliente', value: 'attributes.client_name', align: 'center' },
        { text: 'Número', value: 'attributes.number', align: 'center' },
        { text: 'Motivo', value: 'attributes.motive', align: 'center' },
        { text: 'Valor (R$)', value: 'attributes.value', align: 'center' },
        { text: 'Comentário', value: 'attributes.comment', align: 'center', sortable: false },
        {text: 'Detalhes',  value: 'attributes.details', sortable: false},
        {text: 'Nome local', value: 'attributes.place_name'},
      ],
      loading: false,
      local_selected_clients: [],

      local_filter: {},
    }
  },
  computed: {
    ...mapState({
      allReturnedChecks: state => state.ReturnedCheck.allReturnedChecks,
      status: state => state.Status.allStatuses,
    }),
  },
  methods: {
    handleDoneUpdate(){
      this.getReturnedChecks()
    },
    handleDoneFilter(e){
      this.local_filter = {...e}
      this.getReturnedChecks()
    },
    handleClientSelected(){
      this.local_selected_clients = this.$refs.table.selected_clients
    },
    getReturnedChecks() {
      let filter = {
        by_place_ids: [this.activeModalityId],
        by_statuses: ['concluded'],
        ...this.local_filter
      }
      this.$emit('doneFilter', {...filter} )
      this.loading = true
      if (this.activeModalityId){
        this.indexReturnedChecks(filter).finally(()=>{
          this.loading = false
        })
      }
    },
    handleDateSearch(e){
      const {start_date, end_date} = e
      this.getReturnedChecks(start_date, end_date)
    },
    ...mapActions({
      indexReturnedChecks: 'ReturnedCheck/index',
      indexStatus: 'Status/index',
    })
  },
  mounted () {
    if(this.activeModalityId){
      this.getReturnedChecks()
    }
    if(this.status.length == 0 ){
      this.indexStatus()
    }
    this.registerReturnedChecksListReload(this.getReturnedChecks)
  },
  beforeDestroy() {
    this.registerReturnedChecksListReload(null)
  },
  watch: {
    activeModalityId() {
      this.getReturnedChecks()
    },
  }
}
</script>